module.exports = __webpack_public_path__ + "img/akbank_logo.2f466808.svg";